<template>
  <div>
    <div class="page-header-bar">
      <button class="btn-back" type="button" @click="$router.go(-1)">
        <i class="fas fa-arrow-left"></i>
        <span>Voltar</span>
      </button>
    </div>
    <Classificar
      ref="classificarBuilder"
      v-bind="$props"
      v-slot="props"
      @analysis-loaded="onAnalysisLoaded"
    >
      <!-- Body Text -->
      <b-card-text>
        <span v-if="bootstrapFromItem(props.item)" style="display: none;"></span>
        <b-row>
          <!-- Image -->
          <b-col md="7" cols="12">
            <div class="image-container" :style="{ visibility: urlImage ? 'hidden' : 'visible', position: 'absolute' }">
              <vue-pinch-zoom>
                <img v-if="sourceImageUrl" ref="image" :src="sourceImageUrl" @click="handleImageClick" @load="onImageLoad" alt="Imagem">
                <img v-else-if="props.item.url" ref="image" :src="props.item.url" @click="handleImageClick" @load="onImageLoad" alt="Imagem">
              </vue-pinch-zoom>
            </div>
            <div v-if="urlImage" class="image-container">
              <vue-pinch-zoom>
                <img :src="urlImage" @click="handleImageClick" alt="Imagem">
              </vue-pinch-zoom>
            </div>
          </b-col>

          <!-- Form Space -->
          <b-col md="5" cols="12" style="margin-top: 20px;">
            <div class="analysis-summary">
              <div class="summary-item">
                <span class="summary-label">Peso da amostra</span>
                <span class="summary-value">{{ formatWeightDisplay(analysisSummary.sampleWeight) }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">% Avariados</span>
                <span class="summary-value">{{ formatPercentDisplay(analysisSummary.damagedPercentage) }}</span>
              </div>
            </div>

            <b-form-checkbox v-model="showNumbers" class="mb-3" style="margin: 20px;">
              NUMERAÇÃO GRÃOS
            </b-form-checkbox>

            <div v-for="field in visibleFields" :key="field.name" style="margin: 20px;">
              <label class="typo__label">{{ field.name }}</label>
              <multiselect
                v-model="field.value"
                tag-placeholder="Adicionar Opção"
                placeholder="-- Selecione uma Opção --"
                label="description"
                track-by="key"
                :options="field.options"
                :multiple="true"
              />
            </div>

            <div v-if="form.zoom.value.length > 0" class="zoom-container">
              ZOOM IMAGES
              <div v-for="value in zoomInvertido" class="zoom-images" :key="value.key">
                GRÃO: {{ value.description }} - CLASSIFICAÇÃO: {{ returnGrainClass(value.description) }}
                <br />
                <div class="image-zoom-box">
                  <div v-if="sourceImageUrl">
                    <img :src="sourceImageUrl" style="margin: 5px;" :style="zoomImage(value.description)" alt="Imagem">
                  </div>
                  <div v-else-if="props.item.url">
                    <img v-for="url in props.item.url" :key="url" :src="url" style="margin: 5px;" :style="zoomImage(value.description)" alt="Imagem">
                  </div>
                </div>
              </div>
            </div>

            <div class="chart-container">
              <BarChart v-if="barChartHasData" :chartData="barChartData" :chartOptions="barChartOptions" />
            </div>
          </b-col>
          <!-- End Form -->
        </b-row>
      </b-card-text>
    </Classificar>

    <div v-if="error" class="text-center my-2">
      Erro: {{ error }}
    </div>
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="stylus" scoped>
@import '../../../style/colors.styl';
@import '../../../style/mixins.styl';

.page-header-bar
  display flex
  justify-content flex-end
  align-items center
  width 100%
  padding 16px 24px 8px
  box-sizing border-box

.btn-back
  display inline-flex
  align-items center
  justify-content center
  gap 8px
  background linear-gradient(135deg, #FF8C42 0%, #FF7A29 100%)
  border none
  color white
  padding 10px 20px
  min-height 45px
  border-radius 12px
  cursor pointer
  margin 0
  transition all 0.2s ease
  box-shadow 0 4px 15px rgba(255, 140, 66, 0.3)
  font-family 'Manrope', sans-serif
  font-weight 600
  font-size 15px

  i
    font-size 1rem

.btn-back:hover
  background linear-gradient(135deg, #FF7A29 0%, #FF6810 100%)
  transform translateY(-1px)
  box-shadow 0 6px 20px rgba(255, 140, 66, 0.4)

.header
    color #4472C4
    border-bottom 1px dashed #25292d
    padding-bottom 15px
    margin-bottom 15px
    min-height 60px
    vertical-align middle

.header p
    text-overflow: ellipsis

.btn-show
    float right
    margin-top -15px
    border-radius 32px
    background-color content-theme()
    padding 8px 16px
    color #ffffff
    cursor pointer

.event-btn
    background-color: warning

.image-container
    width: 100%
    height: 100%
    overflow: hidden

.image-container img
    max-width: 100%
    height: auto

.zoom-container
    background-color white
    box-shadow: 0 1px 1px gray
    padding 16px 20px
    border-radius 8px

.zoom-images
    border 1px solid gray
    border-radius 8px
    padding 16px 20px
    margin 10px 0px 10px 0px

.image-zoom-box
    margin-top: 10px

.image-zoom-box img
    max-width: 100%
    height: auto

.analysis-summary
    display flex
    flex-direction column
    gap 12px
    margin 20px
    padding 16px
    background-color white
    border-radius 12px
    box-shadow 0 1px 8px rgba(0, 0, 0, 0.08)

.summary-item
    display flex
    justify-content space-between
    align-items center
    gap 12px

.summary-label
    font-family 'Manrope', sans-serif
    font-weight 600
    color #555
    font-size 14px

.summary-value
    font-family 'Manrope', sans-serif
    font-weight 700
    color #FF8C42
    font-size 1.1rem

.chart-container
    width: 100%
    margin: 0 auto
</style>

<script>
import BarChart from '@/components/static/Inputs/BarChart.vue'
import Classificar from '@/components/builders/Classificar'
import Multiselect from 'vue-multiselect'
import VuePinchZoom from 'vue-pinch-zoom'
import { request, getAnaliseCompleta } from '@/services'

/** Categorias do laudo (AnalysesDetails) usadas no gráfico de barras. */
const LAUDO_CHART_CATEGORIES = [
  { key: 'queimados', label: 'QUEIMADOS' },
  { key: 'queimados_+_ardidos', label: 'QUEIMADOS + ARDIDOS' },
  { key: 'mofados', label: 'MOFADOS' },
  { key: 'fermentados', label: 'FERMENTADOS' },
  { key: 'germinados', label: 'GERMINADOS' },
  { key: 'danificados_+_picados', label: 'DANIFICADOS + PICADOS' },
  { key: 'imaturos', label: 'IMATUROS' },
  { key: 'chochos', label: 'CHOCHOS' }
]

export default {
  components: { Classificar, Multiselect, VuePinchZoom, BarChart },
  props: ['modelKey', 'module'],
  data: () => ({
    error: null,
    jsonData: null,
    form: {
      predict: {
        name: 'Predição',
        value: [],
        options: []
      },
      target: {
        name: 'Alvo',
        value: [],
        options: []
      },
      zoom: {
        name: 'Zoom do grão',
        value: [],
        options: []
      }
    },
    map: {},
    sourceImageUrl: '',
    urlImage: '',
    canvas: null,
    showNumbers: false,
    barChartData: [
      {
        name: 'Classes de Grãos',
        data: []
      }
    ],
    barChartOptions: {
      chart: {
        type: 'bar'
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          endingShape: 'rounded',
          distributed: true
        }
      },
      dataLabels: {
        enabled: false
      },
      yaxis: {
        labels: {
          formatter: (val) => `${Number(val).toFixed(0)}%`
        }
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: (val) => `${Number(val).toFixed(2)}%`
        }
      },
      xaxis: {
        categories: []
      },
      colors: []
    },
    colorMapping: {
      ardido: '#FF4500',
      brasileirinho: '#FFD700',
      casca_marrom: '#8B4513',
      casca_preta: '#000000',
      chocho: '#A9A9A9',
      chochos: '#A9A9A9',
      danificados_picados: '#FF6347',
      derramamento_hilo: '#4682B4',
      esverdeado: '#32CD32',
      fermentado: '#8B0000',
      fermentados: '#8B0000',
      germinado: '#7CFC00',
      germinados: '#7CFC00',
      imaturo: '#ADFF2F',
      imaturos: '#ADFF2F',
      mofado: '#556B2F',
      mofados: '#556B2F',
      partido: '#D3D3D3',
      picado_inteiro: '#FF6347',
      picado_partido: '#FF4500',
      purpura: '#800080',
      queimado: '#8B0000',
      queimados: '#8B0000',
      queimados_ardidos: '#FF4500',
      sadio: '#228B22',
      sujo_terra: '#A52A2A'
    },
    grainsMeta: [],
    initializedFromItem: false,
    analysisSummary: {
      sampleWeight: null,
      damagedPercentage: null
    }
  }),
  computed: {
    visibleFields () {
      return Object.entries(this.form)
        .filter(([key, field]) => key !== 'target' || field.options.length > 0)
        .map(([, field]) => field)
    },
    zoomInvertido () {
      // Verificamos se o array existe e se tem elementos antes de tentar inverter
      if (this.form && this.form.zoom && this.form.zoom.value) {
        return [...this.form.zoom.value].reverse()
      }
      // Se estiver vazio, retornamos um array vazio para não dar erro
      return []
    },
    barChartHasData () {
      const series = this.barChartData[0]
      return Array.isArray(series && series.data) && series.data.length > 0
    }
  },
  beforeDestroy () {
    if (this.sourceImageUrl) {
      URL.revokeObjectURL(this.sourceImageUrl)
    }
  },
  watch: {
    form: {
      handler () {
        // Chama a função para redesenhar retângulos
        this.drawRectangles()
      },
      deep: true
    },
    showNumbers () {
      // Chama a função para redesenhar retângulos quando showNumbers mudar
      this.drawRectangles()
    }
  },
  methods: {
    isSadioKey (key) {
      return this.normalizeClassKey(key) === 'sadio'
    },
    filterSadioFromPredictOptions (options) {
      return (options || []).filter(option => !this.isSadioKey(option.key))
    },
    sanitizePredictFields () {
      this.form.predict.options = this.filterSadioFromPredictOptions(this.form.predict.options)
      this.form.predict.value = (this.form.predict.value || []).filter(
        item => !this.isSadioKey(item.key)
      )
    },
    isExcludedDetailKey (key) {
      const normalized = this.normalizeClassKey(key)
      const ignored = new Set([
        'gross_sample_weight',
        'analysesid',
        'total_damaged',
        'total_damaged_percentage'
      ])
      return ignored.has(normalized) || this.isSadioKey(key)
    },
    formatDetailLabel (key) {
      return String(key || '').replace(/_/g, ' ').replace(/\+/g, '+')
    },
    formatWeightDisplay (value) {
      if (value == null || value === '') return '---'
      const num = Number(String(value).replace(',', '.'))
      if (!Number.isFinite(num)) return String(value)
      return `${num.toFixed(2)} g`
    },
    formatPercentDisplay (value) {
      if (value == null || value === '') return '---'
      const num = Number(String(value).replace(',', '.'))
      if (!Number.isFinite(num)) return String(value)
      return `${num.toFixed(2)}%`
    },
    extractAnalysisSummary (payload) {
      const decoded = this.parseJsonIfNeeded(payload)
      if (!decoded || typeof decoded !== 'object' || Array.isArray(decoded)) {
        return { sampleWeight: null, damagedPercentage: null }
      }
      return {
        sampleWeight: decoded.gross_sample_weight ?? null,
        damagedPercentage: decoded.total_damaged_percentage ?? null
      }
    },
    extractDetailRows (payload) {
      const decodedPayload = this.parseJsonIfNeeded(payload)
      if (!decodedPayload || typeof decodedPayload !== 'object' || Array.isArray(decodedPayload)) {
        return []
      }

      const rows = []
      Object.entries(decodedPayload).forEach(([key, value]) => {
        if (this.isExcludedDetailKey(key)) return
        if (!value || typeof value !== 'object') return

        const percentageRaw = value.percentage ?? value.Percentage
        const weightRaw = value.weight ?? value.Weight
        const percentage = Number(String(percentageRaw || '').replace(',', '.'))
        const weight = Number(String(weightRaw || '').replace(',', '.'))

        if (!Number.isFinite(percentage) && !Number.isFinite(weight)) return

        rows.push({
          key,
          label: this.formatDetailLabel(key),
          percentage: Number.isFinite(percentage) ? `${percentage.toFixed(2)}%` : '---',
          percentageValue: Number.isFinite(percentage) ? percentage : 0,
          weight: Number.isFinite(weight) ? weight.toFixed(2) : '---'
        })
      })

      return rows.map((row, index) => ({ ...row, index: index + 1 }))
    },
    setBarChartFromPercentages (categories, values, keys) {
      this.barChartData = [
        {
          name: 'Classes de Grãos',
          data: values
        }
      ]
      this.barChartOptions = {
        ...this.barChartOptions,
        xaxis: {
          ...this.barChartOptions.xaxis,
          categories
        },
        colors: (keys || []).map(key => this.getClassColor(key))
      }
    },
    /**
     * Popula o gráfico com as % do laudo (AnalysesDetails),
     * nas mesmas categorias exibidas no relatório.
     */
    prepareBarChartFromDetails (detailsPayload) {
      const decoded = this.parseJsonIfNeeded(detailsPayload)
      if (!decoded || typeof decoded !== 'object' || Array.isArray(decoded)) {
        this.setBarChartFromPercentages([], [], [])
        return
      }

      const categories = []
      const values = []
      const keys = []

      LAUDO_CHART_CATEGORIES.forEach(({ key, label }) => {
        const entry = decoded[key]
        if (!entry || typeof entry !== 'object') return

        const percentageRaw = entry.percentage ?? entry.Percentage
        const percentage = Number(String(percentageRaw ?? '').replace(',', '.'))
        if (!Number.isFinite(percentage)) return

        categories.push(label)
        values.push(percentage)
        keys.push(key)
      })

      this.setBarChartFromPercentages(categories, values, keys)
    },
    normalizeClassKey (value) {
      return String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase()
        .replace(/[\s-]+/g, '_')
    },
    getClassColor (classKey) {
      const normalizedKey = this.normalizeClassKey(classKey)
      const withoutSpecialChars = normalizedKey.replace(/[^a-z0-9_+]/g, '')
      const normalizedPlus = withoutSpecialChars.replace(/\+/g, '_')
      const compactKey = normalizedPlus.replace(/_/g, '')

      const aliases = {
        cascapreta: 'casca_preta',
        cascamarrom: 'casca_marrom',
        sujoterra: 'sujo_terra',
        derramamentohilo: 'derramamento_hilo',
        picadointeiro: 'picado_inteiro',
        picadopartido: 'picado_partido',
        queimadosardidos: 'queimados_ardidos',
        danificadospicados: 'danificados_picados'
      }

      const mappedKey =
        this.colorMapping[normalizedKey] ? normalizedKey
          : this.colorMapping[normalizedPlus] ? normalizedPlus
            : aliases[compactKey] || normalizedPlus

      if (this.colorMapping[mappedKey]) {
        return this.colorMapping[mappedKey]
      }

      // Handles labels that come with extra tokens, such as:
      // "grao_esverdeado", "esverdeado(12%)", "classe: ardido"
      const mappingKeys = Object.keys(this.colorMapping)
      const containsMatch = mappingKeys.find(key =>
        normalizedPlus.includes(key) || key.includes(normalizedPlus)
      )
      if (containsMatch) {
        return this.colorMapping[containsMatch]
      }

      return '#808080'
    },
    normalizePredict (predictValue) {
      // Supports both formats:
      // 1) string -> "sadio"
      // 2) object -> { sadio: 0.91, ardido: 0.03, ... }
      if (!predictValue) return ''
      if (typeof predictValue === 'string') return predictValue
      if (typeof predictValue !== 'object') return ''

      const entries = Object.entries(predictValue)
      if (!entries.length) return ''

      const [bestClass] = entries.reduce((best, current) => {
        const bestScore = Number(best[1] || 0)
        const currentScore = Number(current[1] || 0)
        return currentScore > bestScore ? current : best
      })

      return bestClass
    },
    async onAnalysisLoaded (complete) {
      this.error = null
      let payload = complete

      if (!payload) {
        const analysisId = this.$route.params.object_id
        if (analysisId) {
          try {
            payload = await getAnaliseCompleta(analysisId)
          } catch (e) {
            this.error = (e && e.message) || 'Análise não finalizada ou laudo inválido.'
            payload = null
          }
        }
      }

      if (!payload) {
        this.error = 'Dados da análise não encontrados para filtros.'
      } else {
        const loadedFromComplete = await this.processCompleteAnalysis(payload)
        if (!loadedFromComplete) {
          this.error = 'Dados da análise não encontrados para filtros.'
        }
      }

      const builder = this.$refs.classificarBuilder
      if (builder && typeof builder.markAnalysisReady === 'function') {
        builder.markAnalysisReady()
      }
    },
    async processCompleteAnalysis (complete) {
      if (!complete) return false

      try {
        this.analysisSummary = this.extractAnalysisSummary(complete.details)
        // Gráfico do laudo: % vindas de AnalysesDetails (não contagem de grãos)
        this.prepareBarChartFromDetails(complete.details)

        if (complete && complete.imageUrl) {
          if (this.sourceImageUrl) {
            URL.revokeObjectURL(this.sourceImageUrl)
          }
          this.sourceImageUrl = complete.imageUrl
        }

        const grainsRows = this.extractGrainsRows(complete && complete.grains ? complete.grains : null)
        this.grainsMeta = grainsRows

        const parsedGrains = this.extractJsonData(complete && complete.grains ? complete.grains : null)
        if (parsedGrains) {
          this.applyClassificationData(parsedGrains)
          this.applyGrainsMetaOptions(grainsRows)
          this.initializedFromItem = true
          return true
        }

        const parsedDetails = this.extractJsonData(complete && complete.details ? complete.details : null)
        if (parsedDetails) {
          this.applyClassificationData(parsedDetails)
          this.applyGrainsMetaOptions(grainsRows)
          this.initializedFromItem = true
          return true
        }

        if (grainsRows.length > 0) {
          const summaryRowsFromGrains = grainsRows
            .filter(row => !this.isSadioKey(row.key || row.predict))
            .map(row => ({
              key: row.key || row.predict,
              label: this.formatDetailLabel(row.key || row.predict),
              value: Number(String(row.percentage || 0).replace(',', '.')) || 0,
              weight: row.weight
            }))
          this.applySummaryData(summaryRowsFromGrains)
          this.applyGrainsMetaOptions(grainsRows)
          this.initializedFromItem = false
          return true
        }

        const summaryRows = this.extractSummaryRows(complete && complete.details ? complete.details : null)
        if (summaryRows.length > 0) {
          this.applySummaryData(summaryRows)
          // Keep bootstrapFromItem enabled so bbox data can still
          // be loaded from item.analysisData when complete.details
          // only contains summary rows.
          this.initializedFromItem = false
          return true
        }

        return false
      } catch (e) {
        return false
      }
    },
    applyClassificationData (data) {
      if (!data || typeof data !== 'object') return

      this.jsonData = data
      this.form.predict.value = []
      this.form.target.value = []
      this.form.zoom.value = []
      this.form.predict.options = []
      this.form.target.options = []
      this.form.zoom.options = []

      this.loadOptionsMultiselect(this.jsonData)
      this.loadMap(this.jsonData)
      this.sanitizePredictFields()

      if (Object.keys(this.map).length === 0) {
        this.error = 'Dados da análise não encontrados para filtros.'
      } else {
        this.error = null
      }
    },
    applySummaryData (rows) {
      this.jsonData = null
      this.map = {}
      this.form.predict.value = []
      this.form.target.value = []
      this.form.zoom.value = []
      this.form.target.options = []
      this.form.zoom.options = []
      const filteredRows = rows.filter(row => !this.isSadioKey(row.key))
      this.form.predict.options = this.filterSadioFromPredictOptions(
        filteredRows.map(row => ({
          description: row.label,
          key: row.key
        }))
      )
      this.sanitizePredictFields()
      this.error = null
    },
    bootstrapFromItem (item) {
      if (this.initializedFromItem) return false
      if (!item || !item.analysisData) return false

      const parsed = this.extractJsonData(item.analysisData)
      if (!parsed) return false

      this.initializedFromItem = true
      this.applyClassificationData(parsed)
      return true
    },
    parseJsonIfNeeded (value) {
      if (typeof value !== 'string') return value
      const trimmed = value.trim()
      if (!trimmed || (trimmed[0] !== '{' && trimmed[0] !== '[')) return value

      try {
        return JSON.parse(trimmed)
      } catch (e) {
        return value
      }
    },
    mapArrayToGrainObject (list) {
      if (!Array.isArray(list) || list.length === 0) return null

      const mapped = {}
      let hasAnyBbox = false

      list.forEach((item, index) => {
        if (!item || typeof item !== 'object') return
        const bbox = Array.isArray(item.bbox)
          ? item.bbox
          : Array.isArray(item.box)
            ? item.box
            : null

        if (!bbox) return
        hasAnyBbox = true
        const grainKey = String(
          item.index ?? item.grain_index ?? item.id ?? item.object_id ?? index
        )
        mapped[grainKey] = {
          bbox,
          predict: item.predict || item.prediction || item.class || '',
          target: item.target ?? null
        }
      })

      return hasAnyBbox ? mapped : null
    },
    extractGrainsRows (payload) {
      const decoded = this.parseJsonIfNeeded(payload)
      if (!Array.isArray(decoded)) return []

      return decoded
        .filter(item => item && typeof item === 'object')
        .map((item, index) => ({
          index: item.index ?? item.grain_index ?? item.id ?? item.object_id ?? index + 1,
          key: item.key ?? item.class ?? item.predict ?? item.prediction ?? '',
          predict: item.predict ?? item.prediction ?? item.class ?? item.key ?? '',
          weight: item.weight ?? 0,
          percentage: item.percentage ?? item.Percentage ?? 0
        }))
    },
    applyGrainsMetaOptions (rows) {
      if (!Array.isArray(rows) || rows.length === 0) return

      const zoomOptions = rows.map(row => ({
        description: String(row.index),
        key: String(row.index)
      }))
      this.form.zoom.options = Array.from(new Map(zoomOptions.map(option => [option.key, option])).values())

      if (!this.form.predict.options.length) {
        const predictOptions = rows
          .map(row => String(row.key || '').trim())
          .filter(key => Boolean(key) && !this.isSadioKey(key))
          .map(key => ({
            description: key.charAt(0).toUpperCase() + key.slice(1),
            key
          }))
        this.form.predict.options = this.filterSadioFromPredictOptions(
          Array.from(new Map(predictOptions.map(option => [option.key, option])).values())
        )
        this.sanitizePredictFields()
      }
    },
    extractJsonData (payload) {
      const decodedPayload = this.parseJsonIfNeeded(payload)
      if (!decodedPayload || typeof decodedPayload !== 'object') return null

      // 1) Direct grain map: { "0": {bbox, predict, ...}, "1": ... }
      const numericEntries = Object.entries(decodedPayload).filter(([k, v]) => !isNaN(k) && v && Array.isArray(v.bbox))
      if (numericEntries.length > 0) return decodedPayload

      // 2) Grain array formats: [{bbox, predict, target}, ...]
      const directArrayMap = this.mapArrayToGrainObject(decodedPayload)
      if (directArrayMap) return directArrayMap

      // 3) Nested candidates commonly returned by APIs
      const candidates = [
        decodedPayload.analise,
        decodedPayload.analiseData,
        decodedPayload.analysisData,
        decodedPayload.details,
        decodedPayload.data,
        decodedPayload.result
      ]

      for (const candidate of candidates) {
        const parsedCandidate = this.extractJsonData(candidate)
        if (parsedCandidate) return parsedCandidate
      }

      // 4) Explicit list fields (when details come as metadata + list)
      const listCandidates = [
        decodedPayload.graos,
        decodedPayload.grains,
        decodedPayload.itens,
        decodedPayload.items,
        decodedPayload.objects
      ]
      for (const list of listCandidates) {
        const mapped = this.mapArrayToGrainObject(this.parseJsonIfNeeded(list))
        if (mapped) return mapped
      }

      return null
    },
    extractSummaryRows (payload) {
      const detailRows = this.extractDetailRows(payload)
      return detailRows.map(row => ({
        key: row.key,
        label: row.label,
        value: row.percentageValue,
        weight: row.weight
      }))
    },
    loadOptionsMultiselect (jsonData) {
      if (!jsonData || typeof jsonData !== 'object') return

      // Extract unique predict options
      const predictSet = new Set()
      const targetSet = new Set()

      this.form.zoom.options = []

      Object.values(jsonData).forEach(data => {
        if (!data || typeof data !== 'object' || !Array.isArray(data.bbox)) return

        const normalizedPredict = this.normalizePredict(data.predict)
        if (normalizedPredict && !this.isSadioKey(normalizedPredict)) {
          predictSet.add(normalizedPredict)
        }
        if (data.target !== undefined) {
          targetSet.add(data.target)
        }
      })

      this.form.predict.options = this.filterSadioFromPredictOptions(
        Array.from(predictSet).map(predict => ({
          description: predict.charAt(0).toUpperCase() + predict.slice(1),
          key: predict
        }))
      )
      this.sanitizePredictFields()

      this.form.target.options = Array.from(targetSet).map(target => ({
        description: target ? target.charAt(0).toUpperCase() + target.slice(1) : '',
        key: target
      }))

      // Hide target field if all targets are null
      if (targetSet.size === 1 && targetSet.has(null)) {
        this.form.target.options = []
      }

      // Zoom options use only grain numeric keys
      Object.keys(jsonData).forEach(key => {
        if (isNaN(key)) return
        this.form.zoom.options.push({
          description: key,
          key: key
        })
      })
    },
    loadMap (jsonData) {
      if (!jsonData || typeof jsonData !== 'object') return

      // Load the JSON structure into 'map'
      this.map = {}
      Object.entries(jsonData).forEach(([grao, data]) => {
        if (isNaN(grao) || !data || !Array.isArray(data.bbox)) return
        this.$set(this.map, grao, {
          bbox: data.bbox,
          predict: this.normalizePredict(data.predict),
          origin_path: jsonData.origin_path,
          target: data.target
        })
      })
    },
    getSample () {
      const routeSample = String(this.$route.query.sampleId || '').trim()
      if (routeSample) return routeSample
      const params = { ...this.$route.params }
      if (params.analise) return String(params.analise)
      return ''
    },
    onImageLoad () {
      try {
        this.createCanvas()
        this.drawRectangles()
      } catch (e) {
        this.error = e.message || 'Erro ao carregar a imagem.'
      }
    },
    createCanvas () {
      if (!this.$refs.image) {
        this.error = 'Imagem não encontrada.'
        return
      }

      if (this.canvas) {
        // Remove o canvas existente se houver
        this.canvas.parentNode.removeChild(this.canvas)
      }

      this.canvas = document.createElement('canvas')
      this.canvas.width = this.$refs.image.width
      this.canvas.height = this.$refs.image.height

      this.$refs.image.parentNode.appendChild(this.canvas)
    },
    drawRectangles () {
      if (!this.canvas) return

      try {
        // dimensões originais da imagem
        const originalWidth = this.$refs.image.naturalWidth
        const originalHeight = this.$refs.image.naturalHeight

        // dimensões da imagem na div
        const containerWidth = this.$refs.image.offsetWidth
        const containerHeight = this.$refs.image.offsetHeight

        // Limpa o canvas
        const ctx = this.canvas.getContext('2d')
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)

        // Define o tamanho do canvas
        this.canvas.width = containerWidth
        this.canvas.height = containerHeight

        // Desenha a imagem no canvas
        ctx.drawImage(this.$refs.image, 0, 0, containerWidth, containerHeight)

        const graos = Object.entries(this.map)
        const selectedPredicts = this.form.predict.value.map(value => value.key)
        const selectedTargets = this.form.target.value.map(value => value.key)

        graos.forEach(([grainKey, grao]) => {
          if (!grao.bbox) return // Skip if bbox is not defined

          const coords = grao.bbox
          const x = coords[0] * (containerWidth / originalWidth)
          const y = coords[1] * (containerHeight / originalHeight)
          const width = (coords[2] - coords[0]) * (containerWidth / originalWidth)
          const height = (coords[3] - coords[1]) * (containerHeight / originalHeight)

          // Draw overlays only when numbering checkbox is enabled.
          if (this.showNumbers) {
            const matchesPredict = selectedPredicts.includes(grao.predict)
            const matchesTarget = selectedTargets.includes(grao.target)
            const shouldDraw = (selectedPredicts.length === 0 && selectedTargets.length === 0) || matchesPredict || matchesTarget

            if (shouldDraw) {
              ctx.fillStyle = 'white'
              ctx.font = '12px Arial'
              ctx.fillText(grainKey, x + 12, y + 17)

              ctx.strokeStyle = selectedPredicts.includes(grao.predict) ? 'green' : 'red'
              ctx.lineWidth = 2
              ctx.strokeRect(x, y, width, height)
            }
          }
        })

        // Define a URL da imagem do canvas
        this.urlImage = this.canvas.toDataURL()
      } catch (e) {
        this.error = e.message || 'Erro ao desenhar os retângulos no canvas.'
      }
    },
    handleImageClick (event) {
      // Pega a posição do clique relativo ao canto superior esquerdo da imagem
      const rect = this.$refs.image.getBoundingClientRect()
      const x = event.offsetX
      const y = event.offsetY

      // Calcula a escala da imagem renderizada em relação ao tamanho original
      const scaleX = rect.width / this.$refs.image.naturalWidth
      const scaleY = rect.height / this.$refs.image.naturalHeight

      // Encontra o índice do grão clicado com base nas coordenadas
      const clickedGrainEntry = Object.entries(this.map).find(([, grao]) => {
        if (!grao.bbox) return false

        const [x1, y1, x2, y2] = grao.bbox.map((coord, i) => {
          return i % 2 === 0
            ? coord * scaleX
            : coord * scaleY
        })

        // Verifica se o clique está dentro das coordenadas do bbox
        return x >= x1 && x <= x2 && y >= y1 && y <= y2
      })

      if (clickedGrainEntry) {
        const clickedGrainIndex = clickedGrainEntry[0]
        const isDuplicate = this.form.zoom.value.some(item => String(item.key) === String(clickedGrainIndex))
        if (!isDuplicate) {
          this.form.zoom.value.push({ description: clickedGrainIndex, key: clickedGrainIndex })
        }
        console.log(`Grão encontrado: ${clickedGrainIndex}`)
      } else {
        console.log('Clique fora dos grãos.')
      }
    },
    zoomImage (grao) {
      const selectedGrao = this.map[String(grao)]
      if (!selectedGrao || !selectedGrao.bbox) return {}

      const coords = [
        selectedGrao.bbox[0],
        selectedGrao.bbox[1],
        selectedGrao.bbox[2],
        selectedGrao.bbox[3]
      ]

      const x = coords[0]
      const y = coords[1]
      const width = (coords[2] - coords[0])
      const height = (coords[3] - coords[1])

      return {
        objectFit: 'none',
        objectPosition: `-${x}px -${y}px`,
        width: `${width}px`,
        height: `${height}px`
      }
    },
    returnGrainClass (grao) {
      const selectedGrao = this.map[String(grao)]
      if (!selectedGrao || !selectedGrao.bbox) return {}

      return selectedGrao.predict
    },

    reportGenerator () {
      const payload = {
        object_id: this.$route.params.object_id,
        analise: this.getSample(),
        analiseData: this.jsonData
      }

      request.postIot('/relatorio', payload,
        response => {
          console.log(response.data.msg)
        },
        error => {
          const errorMessage = error.response && error.response.data && error.response.data.error ? error.response.data.error : 'Erro desconhecido'
          alert(errorMessage)
        }
      )
    }
  }
}
</script>
